<template>
	<div class='credit-card-info'>
		<h6 class='sub-header primary-color'>
			<div class='payment-option-selection'>
				<span v-if='card_methods.length > 0'>{{getText('OtherMethods')}}</span>
				<span v-if='card_methods.length == 0'>{{getText('NoCardOtherMethods')}}</span>
			</div>
		</h6>

		<div class='row'>
			<div class='col-xs-12 col-lg-4' v-for='item in non_card_methods'>
				<div class='selectable-pay-method' @click='set_method(item)' :class='{active: item.Id == payment_method().Id}'>
					<FormRadio :value='payment_method().Id' :val='item.Id' :title='item.Name'/>
					<img class='pay-logo' :src='"//st.rch.io/methods/"+item.Id+".png"'/>
				</div>
			</div>
		</div>

		<div class='row'>
			<div class='col-sm-12'>
				<div class='default-payment-screen'>
					<div class='container' v-if='issuers_exist'>
						<div class='row'>
							<h6 class='sub-header primary-color'>
								<div class='additional-info'>{{getText('BankAdditional')}}</div>
							</h6>
							<div class='d-sm-block col-sm-12'>
								<FormSelect
									:title="getText('SelectInstitution')"
									:default_text="getText('PleaseSelectBank')"
									:options="issuer_list"
									v-model.lazy="issuer"
									@input="update"/>
							</div>
						</div>
						<br/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.credit-card-info{
		width: 100%;
		margin-top: 50px;
	}
	.payment-option-selection{
		margin-bottom: 20px;
	}
	.additional-info{
		margin-top: 50px;
		margin-bottom: 20px;
	}
	.selectable-pay-method{
		border: 2px solid #CDCDCD;
		border-radius: 7px;
		padding: 25px 20px 17px;
		position: relative;
		margin-bottom: 15px;
		cursor: pointer;

		&:hover, &.active{
			background-color: #F9FDFF;
			border: 2px solid transparent;
		}

		*{
			cursor: pointer !important;
		}

		.pay-logo{
			position: absolute;
			top: 15px;
			height: 45px;
			right: 15px;
		}
	}
</style>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

// Language / Localization
import LanguageService from "@/common/language.service";

import {
	SET_PAYMENT_METHOD,
	SET_ISSUER_ID
} from "@/store/mutations.type";

import FormInput from "@/components/form_elements/FormInput";
import FormNumber from "@/components/form_elements/FormNumber";
import FormSelect from "@/components/form_elements/FormSelect";
import FormRadio from "@/components/form_elements/FormRadio";

export default {
	name: "SecondaryDetails",
	components: {
		FormInput,
		FormSelect,
		FormNumber,
		FormRadio
	},
	props: {
		value: Object
	},
	data(){
		return {
			issuer: ''
		};
	},
	beforeMount(){
		// If we only have 1 Issuer, pre-select it
		if(this.payment_method().Issuers !== undefined){
			if(this.payment_method().Issuers.length >= 1) {
				this.issuer = this.payment_method().Issuers[0].Id;
				this.update();
			}
		}
	},
	computed: {
		non_card_methods(){
			return this.paymentMethods().filter(x => (x.Class != "Card"));
		},
		card_methods(){
			return this.paymentMethods().filter(x => (x.Class == "Card"));
		},
		issuers_exist(){
			// Is there a list of issuers we need to select from?
			if(this.payment_method().Issuers !== undefined){
				if(this.payment_method().Issuers.length > 0) {
					return true;
				}
			}
			return false;
		},
		issuer_list(){
			return this.payment_method().Issuers.map(x => ({ id: x.Id, value: x.Name }));
		}
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		set_method(method){
			Promise.all([
				store.commit(SET_PAYMENT_METHOD, method)
			]);
		},
		update(){
			//Store issuer on update
			store.commit(SET_ISSUER_ID, this.issuer);
		},
		...mapGetters(["payment_method", "paymentMethods"])
	}
}
</script>
